import { forwardRef, useRef, useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useMediaQuery } from '@material-ui/core';
import PropTypes from 'prop-types';

import Close from '@material-ui/icons/Close';

import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'hooks/useTranslation'

function LinearProgressWithLabel(props) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

LinearProgressWithLabel.propTypes = {
	/**
	 * The value of the progress indicator for the determinate and buffer variants.
	 * Value between 0 and 100.
	 */
	value: PropTypes.number.isRequired,
};

export default function SureModal({
	open,
	onClose,
	title,
	header_icon,
	content,
	handleCancel,
	handleButton,
	ProgressValue,
}) {
	const theme = useTheme()
	const { t } = useTranslation()
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
	const descriptionElementRef = useRef(null)
	const [isLoading, setIsLoading] = useState(false)
	useEffect(() => {
		setIsLoading(false)
	}, [open])

	return (
        <Dialog
			className="w-full"
			open={open}
			maxWidth="sm"
			fullWidth
			fullScreen={fullScreen}
			TransitionComponent={Transition}
			scroll="paper">
            <DialogTitle style={{ backgroundColor: '#a74345' }}>
				<Grid
					container
					direction="row"
					justifyContent="space-between"
					alignItems="center">
					<Grid className="flex flex-row items-center" component="div">
						{header_icon}
						<Grid className="text-white">{title}</Grid>
					</Grid>
					<IconButton onClick={onClose} style={{ color: '#fff' }}>
						<Close />
					</IconButton>
				</Grid>
			</DialogTitle>
            <DialogContent dividers>
				<DialogContentText
					className="h-full"
					tabIndex={-1}
					ref={descriptionElementRef}>
					<Grid className="w-full py-10 text-center">{content}</Grid>
					<Grid className="w-full py-10 text-center"
						hidden={!isLoading}
					>
						{ProgressValue ? (
							<>
								{t('sureModal.progressLabel')}
								<LinearProgressWithLabel value={ProgressValue} />
							</>
						)
							:
							(
								// show loading spinner
								(<Box display="flex" justifyContent="center">
                                    <Box m={1}>
										<CircularProgress />
									</Box>
                                </Box>)
							)}
						{t('sureModal.pleaseWait')}
					</Grid>
				</DialogContentText>
			</DialogContent>
            <DialogActions>
				<Grid
					className="w-8/12 mx-auto flex flex-row justify-between items-center"
					component="div">
					<Button
						className="w-5/12"
						onClick={handleCancel}
						color="secondary"
						variant="outlined"
						disabled={isLoading}
						hidden={isLoading}>
						{t('sureModal.cancel')}
					</Button>
					<Button
						className="w-5/12"
						onClick={e => { handleButton(e); setIsLoading(true) }}
						color="primary"
						variant="contained"
						disabled={isLoading}>
						{isLoading ? t('sureModal.processing') : t('sureModal.confirm')}
					</Button>
				</Grid>
			</DialogActions>
        </Dialog>
    );
}

const Transition = forwardRef(function Transtition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})
